package oldcomponents.rules

import oldcomponents.dropdownSelect

import react.dom.div
import react.dom.label
import react.fc
import react.useEffect
import react.useState
import ru.it_mozaika.sender.common.models.Rule


external interface SegmentRuleProps : RuleProps<Rule.Segment> {
    var staticSegments: Map<String, String>
    var dynamicSegments: Map<String, String>
}

val segmentRule = fc<SegmentRuleProps> { props ->

    var notInSegment by useState(false)
    useEffect(props.item) {
//        notInSegment = props.item.not
    }

    var isStaticSegment by useState(props.item.staticSegment)
    useEffect(props.item) {
        isStaticSegment = props.item.staticSegment
    }

    div("form-group row d-flex align-items-center mb-1 pl-2") {
        label("col-3 form-control-label") { +"Сегмент:" }
        div("col-2 p-0") {
            child(dropdownSelect) {
                attrs {
                    dropdownOpenDefault = false
                    multiSelect = false
                    showFilter = false
                    currentValue = mapOf(notInSegment.toString() to if (notInSegment) "Не входит" else "Входит")
                    selectValues = listOf(false.toString() to "Входит", true.toString() to "Не входит")
                    onSave = {
                        props.onChange(props.item.copy(false))
                    }
                }
            }
        }
        div("col-2 p-0") {
            child(dropdownSelect) {
                attrs {
                    dropdownOpenDefault = false
                    multiSelect = false
                    showFilter = false
                    currentValue = mapOf(isStaticSegment.toString() to if (isStaticSegment) "Статический" else "Динамический")
                    selectValues = listOf(false.toString() to "Динамический", true.toString() to "Статический")
                    onSave = {
                        props.onChange(props.item.copy(staticSegment = it.keys.firstOrNull()?.toBooleanStrictOrNull() ?: false))
                    }
                }
            }
        }
        div("col-5 p-0") {
            child(dropdownSelect) {
                attrs {
                    dropdownOpenDefault = false
                    multiSelect = false
                    showFilter = false
                    currentValue = mapOf(props.item.id to (if (isStaticSegment) props.staticSegments else props.dynamicSegments)[props.item.id].orEmpty())
                    selectValues = (if (isStaticSegment) props.staticSegments else props.dynamicSegments).map { it.key to it.value }
                    onSave = {
                        props.onChange(props.item.copy(id = it.keys.firstOrNull().orEmpty()))
                    }
                }
            }
        }
    }
}